import { createEvent, createStore, sample } from "effector"
import { createGate } from "effector-react"
import { AppPanels, AppPanelsT } from "src/app/providers/RouteProvider/lib/routeConfig"

export const ActivePanelGate = createGate()

export const setActivePanel = createEvent<AppPanelsT>()
export const $activePanel = createStore<AppPanelsT>(AppPanels.SECOND_STAGE_VOITING)

export const $prevActivePanel = createStore<AppPanelsT | null>(null)

sample({
  clock: setActivePanel,
  source: $activePanel,
  target: $prevActivePanel,
})

sample({
  clock: $prevActivePanel,
  source: setActivePanel,
  target: $activePanel,
})

sample({
  clock: ActivePanelGate.open,
  filter: () => !!window.location.hash,
  fn: () => window.location.hash.slice(1) as AppPanelsT,
  target: setActivePanel,
})
